import Colors from "assets/Colors";
import styled from "styled-components";

const TopContainer = styled.div`
  padding-top: 17px;
  padding-right: 19px;
  padding-left: 19px;
  width: 100%;
  display: flex;
  justify-content: space-between;
  margin: 0 auto;
  margin-top: 10px;
  background: ${Colors.background_secondary};
  border - radius: 2px;
  box-shadow: 0px 6px 24px rgba(0, 0, 0, 0.06);
  max - width: 100vw;
  margin-bottom: 32px;
  flex-wrap: wrap;
  @media (max-width: 768px) {
    flex-direction: column;
    padding: 10px 10px;
  }
`;

const ContainerDatePicker = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 0px 20px;
`;

const ContainerPagination = styled.div`
  display: flex;
  justify-content: start;
  align-items: center;
`;
const elemetPagination = styled.div`
  height: 41px;
  border: 1px solid ${Colors.background_dividers};
  background-color: ${({ select }) => select && Colors.primary};
  color: ${({ select }) => select && "#fff"};
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 40px;
`;

const downloadButtonContainer = styled.div`
  display: flex;
  flex-direction: column;
  margin-bottom: 10px;
  // @media (min-width: 1280px) {
  //   display: none;
  // }
`;

const Title = styled.div`
  font-style: normal;
  font-weight: 300;
  font-size: 12px;
  line-height: 14px;
  display: flex;
  align-items: center;
  color: ${Colors.text_primary};
  margin-bottom: 13px;
`;

const Title2 = styled.div`
  font-style: normal;
  font-weight: 300;
  font-size: 12px;
  line-height: 14px;
  display: flex;
  align-items: center;
  color: ${Colors.text_primary};
  margin-bottom: 13px;

  @media (max-width: 585px) {
    display: none;
    margin-bottom: 0px;
  }
`;

export default {
  TopContainer,
  ContainerDatePicker,
  ContainerPagination,
  elemetPagination,
  Title,
  Title2,
  downloadButtonContainer,
};
